import { SESSION_COOKIE_NAME } from "@/utils/constants";

export interface UserSession {
  id: number;
  name: string;
  email: string;
  email_verified_at: string | null;
  google_id?: string;
  avatar: string;
  api_token: string | null;
  free_videos_remaining: number;
  free_videos_used: number;
  created_at: string;
  updated_at: string;
  uuid: string;
  code: string | null;
  hard_limit: string;
  token: string;
}

export const setAuthSession = (data: UserSession) => {
  const cookieValue = encodeURIComponent(JSON.stringify(data));

  // Set cookie with secure flags
  document.cookie = `${SESSION_COOKIE_NAME}=${cookieValue}; Path=/; ${
    process.env.NODE_ENV === "production" ? "Secure; " : ""
  }SameSite=Lax; max-age=${60 * 60 * 24 * 7}`; // 1 week expiration
};

export const getAuthSession = (): UserSession | null => {
  try {
    const cookies = document.cookie.split(";");
    const sessionCookie = cookies.find((c) =>
      c.trim().startsWith(`${SESSION_COOKIE_NAME}=`)
    );

    if (!sessionCookie) return null;

    const value = sessionCookie.split("=")[1];
    return JSON.parse(decodeURIComponent(value));
  } catch (error) {
    console.error("Session parse error:", error);
    return null;
  }
};

export const clearAuthSession = () => {
  document.cookie = `${SESSION_COOKIE_NAME}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
